import {
  Avatar, Collapse, Divider, ListItem, Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT } from '../../../../consts';
import { InfoBlack } from '../../../../icons/info-black';
import { InfoWhite } from '../../../../icons/info-white';
import STRING_KEYS from '../../../../language/keys';
import { HistoryListCollapse } from '../HistoryListCollapse';
import { style } from './style';

type HistoryListItemProps = {
  userFirstName: string,
  userLastName: string,
  data: HistoryValues,
  userAvatarUrl: string,
  createdAt: string | Date,
  titleEditor: string,
  actionType: string,
}

export const HistoryListItem = ({
  userFirstName,
  userLastName,
  data,
  userAvatarUrl: imageUrl,
  createdAt,
  titleEditor,
  actionType,
}: HistoryListItemProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
  const handleShowDetails = () => {
    setIsOpenDetails((prev) => !prev);
  };

  const fullName = `${userFirstName} ${userLastName}`;

  const getFirstLetter = (text: string) => {
    return text.charAt(0).toLocaleUpperCase();
  };

  return (
    <ListItem
      sx={ style.list.listItem.sx }
    >
      <Box sx={ style.list.listItem.sx }>
        <Box sx={ style.list.listItem.col }
          onClick={ handleShowDetails }
        >
          <Box sx={ style.list.listItem.col }>
            <Avatar
              sx={ style.list.avatar.sx }
              alt={ fullName }
              src={ imageUrl }
            >
              {`${getFirstLetter(userFirstName)}${getFirstLetter(userLastName)}`}
            </Avatar>
            <Box
              sx={ style.list.editorText }
            >
              <Box sx={ style.list.listItem.row }>
                <Typography
                  sx={ style.list.listItem.Typography }
                  variant="subtitle2"
                >
                  { fullName }
                </Typography>
                <Typography variant="body2">
                  { translate(STRING_KEYS.TITLE_EDIT_TEXT, { value: titleEditor }) }
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary">
                { moment(new Date(createdAt)).format(DATE_FORMAT.HISTORY) }
              </Typography>
            </Box>
          </Box>
          { isOpenDetails ? <InfoBlack /> : <InfoWhite /> }
        </Box>
        <Collapse
          in={ isOpenDetails }
          sx={ style.list.listItem.collapsedBlock }
        >
          <HistoryListCollapse
            data={ data }
            actionType={ actionType }
            titleEditor={ titleEditor }
          />
        </Collapse>
        <Divider sx={ style.list.divider.sx } />
      </Box>
    </ListItem>
  );
};
